import { Link } from "react-router-dom";

const links = [
  { to: "/category", label: "影视作品库", icon: "ri-film-line" },
  { to: "/news", label: "资讯动态", icon: "ri-article-line" },
  { to: "/special", label: "专题合集", icon: "ri-bookmark-3-line" },
];

export default function NotFound() {
  return (
    <section className="flex min-h-[78vh] items-center justify-center px-4 pb-16 pt-28">
      <div className="w-full max-w-2xl text-center">
        <p className="font-label text-6xl leading-none tracking-[0.12em] text-accent-500 md:text-8xl">
          404
        </p>
        <h1 className="mt-4 text-2xl font-semibold text-foreground-950 md:text-3xl">
          这一页不在档案库里
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          链接可能已经失效，或者内容已被移除。你可以回到首页，或从下面的入口继续浏览。
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm text-foreground-950 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            <span className="whitespace-nowrap">返回首页</span>
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 rounded-md border border-background-600 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-400"
          >
            <span className="whitespace-nowrap">浏览作品列表</span>
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
        <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-3">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="flex items-center gap-2 rounded-md border border-background-800 bg-background-900 px-4 py-3 text-sm text-foreground-600 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              <i className={`${link.icon} text-accent-500`} aria-hidden="true"></i>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}